import { isElectron } from '@/utils/electron'

export async function isDownloadingUpdates() {
  if (!isElectron()) {
    return false
  }

  // eslint-disable-next-line no-return-await
  return await window.ipcRenderer.invoke('is-downloading-updates')
}

export async function quitAndInstall() {
  if (!isElectron()) {
    return
  }
  await window.ipcRenderer.send('quit-and-install')
}

export async function checkForUpdates() {
  if (!isElectron()) {
    return
  }
  await window.ipcRenderer.send('check-for-updates')
}
